import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../store';
import { actionCreators as BookingActions } from '../store/Booking';
import { PurchaseTypes } from '../store/PurchaseTypes';
import { CAMPAIGN_CONFIG } from '../components/tiered-group-size-discount/tieredGroupSizeDiscountConfig';

const useTieredGroupSizeDiscountPromo = () => {

	const dispatch = useDispatch();

	const isEnabled = CAMPAIGN_CONFIG.enabled;
	const selectedPurchaseType = useSelector((state: IApplicationState) => state.purchaseType.selectedPurchaseType);
	const selectedSession = useSelector((state: IApplicationState) => state.session.selectedSession);
	const playerCount = useSelector((state: IApplicationState) => state.players.selectedPlayers);
	const preSelectedCode = useSelector((state: IApplicationState) => state.booking.preSelectedCode);

	useEffect(() => {

		if (!isEnabled) {
			return;
		}
		if (selectedPurchaseType !== PurchaseTypes.Booking) {
			return;
		}
		if (CAMPAIGN_CONFIG.attractionTypeId !== undefined
			&& selectedSession?.package?.attractionTypeId !== CAMPAIGN_CONFIG.attractionTypeId) {
			return;
		}

		// determine the correct code for the current player count
		let correctCode: string | undefined;
		if (playerCount !== undefined) {
			const mapping = CAMPAIGN_CONFIG.promoCodes.find(
				(m) => playerCount >= m.minPlayers && playerCount <= m.maxPlayers
			);
			correctCode = mapping?.code;
		}

		if (correctCode === undefined) {
			// only clear codes that this campaign previously set;
			// leave non-campaign codes (e.g. from URL params) intact
			if (preSelectedCode && CAMPAIGN_CONFIG.allCampaignCodes.includes(preSelectedCode)) {
				dispatch(BookingActions.recordPreselectedCode(null));
			}
			return;
		}

		// only dispatch if the correct code differs from what's already set
		if (correctCode && correctCode !== preSelectedCode) {
			dispatch(BookingActions.recordPreselectedCode(correctCode));
		}
	}, [isEnabled, selectedPurchaseType, selectedSession, playerCount, preSelectedCode, dispatch]);
};

export default useTieredGroupSizeDiscountPromo;
